export default __webpack_public_path__ + "static/media/relax.2875b34e.png";